<template>
  <!-- eslint-disable vue/no-v-html -->
  <span
    :style="rotate ? `transform: rotate(${rotate}deg)` : ''"
    class="fluent-svg"
    v-bind="$attrs"
    v-html="svg"
  ></span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

// Alphabetical order
import Apps16Regular from '@fluentui/svg-icons/icons/apps_16_regular.svg?raw';
import AppsList24Regular from '@fluentui/svg-icons/icons/apps_list_24_regular.svg?raw';
import ArrowDownload16Filled from '@fluentui/svg-icons/icons/arrow_download_16_filled.svg?raw';
import ArrowEnterLeft20Regular from '@fluentui/svg-icons/icons/arrow_enter_left_20_regular.svg?raw';
import ArrowExportLtr16Filled from '@fluentui/svg-icons/icons/arrow_export_ltr_16_filled.svg?raw';
import ArrowImport16Filled from '@fluentui/svg-icons/icons/arrow_import_16_filled.svg?raw';
import ArrowMaximize16Regular from '@fluentui/svg-icons/icons/arrow_maximize_16_regular.svg?raw';
import ArrowMove20Filled from '@fluentui/svg-icons/icons/arrow_move_20_filled.svg?raw';
import ArrowRedo16Filled from '@fluentui/svg-icons/icons/arrow_redo_16_filled.svg?raw';
import ArrowSort16Filled from '@fluentui/svg-icons/icons/arrow_sort_16_filled.svg?raw';
import ArrowSortDown16Filled from '@fluentui/svg-icons/icons/arrow_sort_down_16_filled.svg?raw';
import ArrowSortUp16Filled from '@fluentui/svg-icons/icons/arrow_sort_up_16_filled.svg?raw';
import ArrowAutofitWidth20Regular from '@fluentui/svg-icons/icons/arrow_autofit_width_20_regular.svg?raw';
import ArrowSwap16Filled from '@fluentui/svg-icons/icons/arrow_swap_16_filled.svg?raw';
import ArrowTrending24Regular from '@fluentui/svg-icons/icons/arrow_trending_24_regular.svg?raw';
import ArrowTrendingDown24Regular from '@fluentui/svg-icons/icons/arrow_trending_down_24_regular.svg?raw';
import ArrowUndo16Filled from '@fluentui/svg-icons/icons/arrow_undo_16_filled.svg?raw';
import ArrowUpload16Filled from '@fluentui/svg-icons/icons/arrow_upload_16_filled.svg?raw';
import Attach16Filled from '@fluentui/svg-icons/icons/attach_16_filled.svg?raw';
import Archive16Regular from '@fluentui/svg-icons/icons/archive_16_regular.svg?raw';
import BookInformation24Regular from '@fluentui/svg-icons/icons/book_information_24_regular.svg?raw';
import BookmarkAdd16Regular from '@fluentui/svg-icons/icons/bookmark_add_24_regular.svg?raw';
import BranchCompare16Regular from '@fluentui/svg-icons/icons/branch_compare_16_regular.svg?raw';
import BranchRequest16Regular from '@fluentui/svg-icons/icons/branch_request_16_regular.svg?raw';
import CalculatorMultiple24Regular from '@fluentui/svg-icons/icons/calculator_multiple_24_regular.svg?raw';
import CalendarAdd24Regular from '@fluentui/svg-icons/icons/calendar_add_24_regular.svg?raw';
import CalendarArrowRight16Regular from '@fluentui/svg-icons/icons/calendar_arrow_right_16_regular.svg?raw';
import CalendarClock16Regular from '@fluentui/svg-icons/icons/calendar_clock_16_regular.svg?raw';
import CalendarDataBar24Regular from '@fluentui/svg-icons/icons/calendar_data_bar_24_regular.svg?raw';
import CalendarEdit24Regular from '@fluentui/svg-icons/icons/calendar_edit_24_regular.svg?raw';
import CalendarError20Regular from '@fluentui/svg-icons/icons/calendar_error_20_regular.svg?raw';
import CalendarLtr24Regular from '@fluentui/svg-icons/icons/calendar_ltr_24_regular.svg?raw';
import CalendarSync24Regular from '@fluentui/svg-icons/icons/calendar_sync_24_regular.svg?raw';
import Camera20Regular from '@fluentui/svg-icons/icons/camera_20_regular.svg?raw';
import CaretDown16Filled from '@fluentui/svg-icons/icons/caret_down_16_filled.svg?raw';
import CaretDown16Regular from '@fluentui/svg-icons/icons/caret_down_16_regular.svg?raw';
import CaretUp16Filled from '@fluentui/svg-icons/icons/caret_up_16_filled.svg?raw';
import ChartMultiple20Regular from '@fluentui/svg-icons/icons/chart_multiple_20_regular.svg?raw';
import ChartMultiple24Regular from '@fluentui/svg-icons/icons/chart_multiple_24_regular.svg?raw';
import Chat48Regular from '@fluentui/svg-icons/icons/chat_48_regular.svg?raw';
import ChatSparkle16Regular from '@fluentui/svg-icons/icons/chat_sparkle_24_regular.svg?raw';
import CheckboxChecked16Regular from '@fluentui/svg-icons/icons/checkbox_checked_16_regular.svg?raw';
import ClipboardLink16Regular from '@fluentui/svg-icons/icons/clipboard_link_16_regular.svg?raw';
import ClipboardTaskListLtr24Regular from '@fluentui/svg-icons/icons/clipboard_task_list_ltr_24_regular.svg?raw';
import Clock16Regular from '@fluentui/svg-icons/icons/clock_16_regular.svg?raw';
import CloudLink16Regular from '@fluentui/svg-icons/icons/cloud_link_16_regular.svg?raw';
import CloudLink20Regular from '@fluentui/svg-icons/icons/cloud_link_20_regular.svg?raw';
import Code16Filled from '@fluentui/svg-icons/icons/code_16_filled.svg?raw';
import Color24Regular from '@fluentui/svg-icons/icons/color_24_regular.svg?raw';
import ColumnArrowRight20Regular from '@fluentui/svg-icons/icons/column_arrow_right_20_regular.svg?raw';
import Comment16Regular from '@fluentui/svg-icons/icons/comment_16_regular.svg?raw';
import Comment24Regular from '@fluentui/svg-icons/icons/comment_24_regular.svg?raw';
import CommentMultiple24Regular from '@fluentui/svg-icons/icons/comment_multiple_24_regular.svg?raw';
import Compose16Filled from '@fluentui/svg-icons/icons/compose_16_filled.svg?raw';
import CopyAdd20Regular from '@fluentui/svg-icons/icons/copy_add_24_regular.svg?raw';
import CreditCardPerson24Regular from '@fluentui/svg-icons/icons/credit_card_person_24_regular.svg?raw';
import DarkTheme20Filled from '@fluentui/svg-icons/icons/dark_theme_20_filled.svg?raw';
import DataTrending24Regular from '@fluentui/svg-icons/icons/data_trending_24_regular.svg?raw';
import DecimalArrowRight20Regular from '@fluentui/svg-icons/icons/decimal_arrow_right_20_regular.svg?raw';
import Delete24Regular from '@fluentui/svg-icons/icons/delete_24_regular.svg?raw';
import Dismiss16Filled from '@fluentui/svg-icons/icons/dismiss_16_filled.svg?raw';
import Document16Regular from '@fluentui/svg-icons/icons/document_16_regular.svg?raw';
import DocumentAdd16Regular from '@fluentui/svg-icons/icons/document_add_16_regular.svg?raw';
import DocumentArrowRight20Regular from '@fluentui/svg-icons/icons/document_arrow_right_20_regular.svg?raw';
import DocumentPdf20Regular from '@fluentui/svg-icons/icons/document_pdf_20_regular.svg?raw';
import DoorArrowRight20Regular from '@fluentui/svg-icons/icons/door_arrow_right_20_regular.svg?raw';
import Emoji16Regular from '@fluentui/svg-icons/icons/emoji_16_regular.svg?raw';
import EmojiAdd16Regular from '@fluentui/svg-icons/icons/emoji_add_16_regular.svg?raw';
import Eyedropper20Filled from '@fluentui/svg-icons/icons/eyedropper_20_filled.svg?raw';
import EyeShow24Filled from '@fluentui/svg-icons/icons/eye_24_filled.svg?raw';
import EyeShow24Regular from '@fluentui/svg-icons/icons/eye_24_regular.svg?raw';
import FlowChart24Regular from '@fluentui/svg-icons/icons/flowchart_24_regular.svg?raw';
import FolderAdd20Regular from '@fluentui/svg-icons/icons/folder_add_20_regular.svg?raw';
import GanttChart24Regular from '@fluentui/svg-icons/icons/gantt_chart_24_regular.svg?raw';
import Gauge24Regular from '@fluentui/svg-icons/icons/gauge_24_regular.svg?raw';
import GridDots20Filled from '@fluentui/svg-icons/icons/grid_dots_20_filled.svg?raw';
import GroupList24Filled from '@fluentui/svg-icons/icons/group_list_24_filled.svg?raw';
import HatGraduation16Filled from '@fluentui/svg-icons/icons/hat_graduation_16_filled.svg?raw';
import HatGraduation16Regular from '@fluentui/svg-icons/icons/hat_graduation_16_regular.svg?raw';
import Headset24Regular from '@fluentui/svg-icons/icons/headset_24_regular.svg?raw';
import ImageAdd24Regular from '@fluentui/svg-icons/icons/image_add_24_regular.svg?raw';
import Info16Filled from '@fluentui/svg-icons/icons/info_16_filled.svg?raw';
import Info16Regular from '@fluentui/svg-icons/icons/info_16_regular.svg?raw';
import LineHorizontal120Filled from '@fluentui/svg-icons/icons/line_horizontal_1_20_regular.svg?raw';
import Link16Filled from '@fluentui/svg-icons/icons/link_16_filled.svg?raw';
import LinkDismiss16Filled from '@fluentui/svg-icons/icons/link_dismiss_16_filled.svg?raw';
import LockClosed16Filled from '@fluentui/svg-icons/icons/lock_closed_16_filled.svg?raw';
import LockOpen16Filled from '@fluentui/svg-icons/icons/lock_open_16_filled.svg?raw';
import Mail16Regular from '@fluentui/svg-icons/icons/mail_16_regular.svg?raw';
import MailAlert16Regular from '@fluentui/svg-icons/icons/mail_alert_16_regular.svg?raw';
import MailDismiss16Regular from '@fluentui/svg-icons/icons/mail_dismiss_16_regular.svg?raw';
import MailUnread16Regular from '@fluentui/svg-icons/icons/mail_unread_16_regular.svg?raw';
import MoreVertical16Regular from '@fluentui/svg-icons/icons/more_vertical_16_regular.svg?raw';
import Notepad16Regular from '@fluentui/svg-icons/icons/notepad_16_regular.svg?raw';
import Open16Filled from '@fluentui/svg-icons/icons/open_16_filled.svg?raw';
import OpenFolderIcon from '@fluentui/svg-icons/icons/open_folder_28_regular.svg?raw';
import Options16Regular from '@fluentui/svg-icons/icons/options_16_regular.svg?raw';
import Organization16Regular from '@fluentui/svg-icons/icons/organization_16_regular.svg?raw';
import Organization20Regular from '@fluentui/svg-icons/icons/organization_20_regular.svg?raw';
import PanelRightContract20Regular from '@fluentui/svg-icons/icons/panel_right_contract_20_regular.svg?raw';
import PanelRightExpand20Regular from '@fluentui/svg-icons/icons/panel_right_expand_20_regular.svg?raw';
import Person48Filled from '@fluentui/svg-icons/icons/person_48_filled.svg?raw';
import PersonClock16Regular from '@fluentui/svg-icons/icons/person_clock_16_regular.svg?raw';
import Phone16Regular from '@fluentui/svg-icons/icons/phone_16_regular.svg?raw';
import PlayCircle24RegularIcon from '@fluentui/svg-icons/icons/play_circle_24_regular.svg?raw';
import QuestionCircle24Regular from '@fluentui/svg-icons/icons/question_circle_24_regular.svg?raw';
import RecordStop24Regular from '@fluentui/svg-icons/icons/record_stop_24_regular.svg?raw';
import ReplyAll16Filled from '@fluentui/svg-icons/icons/arrow_reply_all_16_filled.svg?raw';
import SaveCopy24Regular from '@fluentui/svg-icons/icons/save_copy_24_regular.svg?raw';
import Scales24Regular from '@fluentui/svg-icons/icons/scales_24_regular.svg?raw';
import Send16Filled from '@fluentui/svg-icons/icons/send_16_filled.svg?raw';
import Settings20Regular from '@fluentui/svg-icons/icons/settings_20_regular.svg?raw';
import ShareAndroid20Regular from '@fluentui/svg-icons/icons/share_android_20_regular.svg?raw';
import ShieldLockRegular from '@fluentui/svg-icons/icons/shield_lock_16_regular.svg?raw';
import Star16Regular from '@fluentui/svg-icons/icons/star_16_regular.svg?raw';
import Star20Filled from '@fluentui/svg-icons/icons/star_20_filled.svg?raw';
import StarOff16Regular from '@fluentui/svg-icons/icons/star_off_16_regular.svg?raw';
import Table16Regular from '@fluentui/svg-icons/icons/table_16_regular.svg?raw';
import TaskListLtr24Regular from '@fluentui/svg-icons/icons/task_list_ltr_24_regular.svg?raw';
import TaskListSquareLtr24Regular from '@fluentui/svg-icons/icons/task_list_square_ltr_24_regular.svg?raw';
import TextBold16Filled from '@fluentui/svg-icons/icons/text_bold_16_filled.svg?raw';
import TextBulletListLtr24Regular from '@fluentui/svg-icons/icons/text_bullet_list_ltr_24_regular.svg?raw';
import TextClearFormatting16Filled from '@fluentui/svg-icons/icons/text_clear_formatting_16_regular.svg?raw';
import TextCollapse24Regular from '@fluentui/svg-icons/icons/text_collapse_24_regular.svg?raw';
import TextColor16Filled from '@fluentui/svg-icons/icons/text_color_16_filled.svg?raw';
import TextExpand24Regular from '@fluentui/svg-icons/icons/text_expand_24_regular.svg?raw';
import TextField16Regular from '@fluentui/svg-icons/icons/text_field_16_regular.svg?raw';
import TextIndentDecrease16Filled from '@fluentui/svg-icons/icons/text_indent_decrease_ltr_16_filled.svg?raw';
import TextIndentIncrease16Filled from '@fluentui/svg-icons/icons/text_indent_increase_ltr_16_filled.svg?raw';
import TextItalic16Filled from '@fluentui/svg-icons/icons/text_italic_16_filled.svg?raw';
import TextNumberListLtr16Filled from '@fluentui/svg-icons/icons/text_number_list_ltr_16_filled.svg?raw';
import TextQuote16Filled from '@fluentui/svg-icons/icons/text_quote_16_filled.svg?raw';
import TextStrikethrough16Filled from '@fluentui/svg-icons/icons/text_strikethrough_16_filled.svg?raw';
import TextUnderline16Filled from '@fluentui/svg-icons/icons/text_underline_16_filled.svg?raw';
import Timeline24Regular from '@fluentui/svg-icons/icons/timeline_24_regular.svg?raw';
import Timer24Regular from '@fluentui/svg-icons/icons/timer_24_regular.svg?raw';
import ToggleLeft16Regular from '@fluentui/svg-icons/icons/toggle_left_16_regular.svg?raw';
import Warning16Regular from '@fluentui/svg-icons/icons/warning_16_regular.svg?raw';
import WeatherMoon16Regular from '@fluentui/svg-icons/icons/weather_moon_16_regular.svg?raw';
import WeatherSunny16Regular from '@fluentui/svg-icons/icons/weather_sunny_16_regular.svg?raw';
import DualScreenSpan20Regular from '@fluentui/svg-icons/icons/dual_screen_span_20_regular.svg?raw';
import BrainCircuit20Regular from '@fluentui/svg-icons/icons/brain_circuit_20_regular.svg?raw';
import DataBarHorizontal24Regular from '@fluentui/svg-icons/icons/data_bar_horizontal_24_regular.svg?raw';
import TableDeleteRow24Regular from '@fluentui/svg-icons/icons/table_delete_row_24_regular.svg?raw';
import TableDeleteColumn24Regular from '@fluentui/svg-icons/icons/table_delete_column_24_regular.svg?raw';

// Alphabetical order
const FluentIconsMap = {
  apps: Apps16Regular,
  apps_list: AppsList24Regular,
  arrow_download: ArrowDownload16Filled,
  arrow_enter_left: ArrowEnterLeft20Regular,
  arrow_export: ArrowExportLtr16Filled,
  arrow_import: ArrowImport16Filled,
  arrow_maximize: ArrowMaximize16Regular,
  arrow_move: ArrowMove20Filled,
  arrow_redo: ArrowRedo16Filled,
  arrow_sort: ArrowSort16Filled,
  arrow_sort_up: ArrowSortUp16Filled,
  arrow_sort_down: ArrowSortDown16Filled,
  arrow_autofit_width: ArrowAutofitWidth20Regular,
  arrow_swap: ArrowSwap16Filled,
  arrow_trending_down: ArrowTrendingDown24Regular,
  arrow_trending: ArrowTrending24Regular,
  arrow_undo: ArrowUndo16Filled,
  arrow_upload: ArrowUpload16Filled,
  attach: Attach16Filled,
  archive: Archive16Regular,
  book_information: BookInformation24Regular,
  bookmark_add: BookmarkAdd16Regular,
  branch_compare: BranchCompare16Regular,
  branch_request: BranchRequest16Regular,
  calculator_multiple: CalculatorMultiple24Regular,
  calendar_add: CalendarAdd24Regular,
  calendar_arrow_right: CalendarArrowRight16Regular,
  calendar_clock: CalendarClock16Regular,
  calendar_data_bar: CalendarDataBar24Regular,
  calendar_edit: CalendarEdit24Regular,
  calendar_error: CalendarError20Regular,
  calendar_sync: CalendarSync24Regular,
  calendar: CalendarLtr24Regular,
  camera: Camera20Regular,
  caret_down_outline: CaretDown16Regular,
  caret_down: CaretDown16Filled,
  caret_up: CaretUp16Filled,
  chart_multiple_20: ChartMultiple20Regular,
  chart_multiple_24: ChartMultiple24Regular,
  chat_sparkle: ChatSparkle16Regular,
  chat: Chat48Regular,
  checkbox_checked: CheckboxChecked16Regular,
  clipboard_link: ClipboardLink16Regular,
  clipboard_task_list: ClipboardTaskListLtr24Regular,
  clock: Clock16Regular,
  cloud_link_20: CloudLink20Regular,
  cloud_link: CloudLink16Regular,
  code: Code16Filled,
  color: Color24Regular,
  column_arrow_right: ColumnArrowRight20Regular,
  comment_24: Comment24Regular,
  comment_multiple: CommentMultiple24Regular,
  comment: Comment16Regular,
  compose: Compose16Filled,
  copy_add: CopyAdd20Regular,
  credit_card_person: CreditCardPerson24Regular,
  dark_theme: DarkTheme20Filled,
  data_trending: DataTrending24Regular,
  decimal_arrow_right: DecimalArrowRight20Regular,
  delete: Delete24Regular,
  dismiss: Dismiss16Filled,
  document: Document16Regular,
  document_add: DocumentAdd16Regular,
  document_arrow_right: DocumentArrowRight20Regular,
  document_pdf_20: DocumentPdf20Regular,
  door_arrow_right: DoorArrowRight20Regular,
  dual_screen_span: DualScreenSpan20Regular,
  emoji_add: EmojiAdd16Regular,
  emoji: Emoji16Regular,
  eye_show: EyeShow24Regular,
  eye_show_filled: EyeShow24Filled,
  eyedropper: Eyedropper20Filled,
  flowchart: FlowChart24Regular,
  folder_add: FolderAdd20Regular,
  gantt_chart: GanttChart24Regular,
  gauge: Gauge24Regular,
  grid_dots: GridDots20Filled,
  group_list: GroupList24Filled,
  hat_graduation_regular: HatGraduation16Regular,
  hat_graduation: HatGraduation16Filled,
  headset: Headset24Regular,
  image_add: ImageAdd24Regular,
  info: Info16Regular,
  info_filled: Info16Filled,
  line_1: LineHorizontal120Filled,
  link_dismiss: LinkDismiss16Filled,
  link: Link16Filled,
  lock_filled: LockClosed16Filled,
  lock_open_filled: LockOpen16Filled,
  mail_alert: MailAlert16Regular,
  mail_dismiss: MailDismiss16Regular,
  mail_unread: MailUnread16Regular,
  mail: Mail16Regular,
  moon: WeatherMoon16Regular,
  more_vertical: MoreVertical16Regular,
  notepad: Notepad16Regular,
  open_folder: OpenFolderIcon,
  open: Open16Filled,
  options: Options16Regular,
  organization_16: Organization16Regular,
  organization: Organization20Regular,
  panel_right_contract: PanelRightContract20Regular,
  panel_right_expand: PanelRightExpand20Regular,
  person_clock: PersonClock16Regular,
  person: Person48Filled,
  phone: Phone16Regular,
  play_circle: PlayCircle24RegularIcon,
  question_circle: QuestionCircle24Regular,
  record_stop: RecordStop24Regular,
  reply_all: ReplyAll16Filled,
  save_copy: SaveCopy24Regular,
  scales: Scales24Regular,
  send: Send16Filled,
  settings: Settings20Regular,
  share_android: ShareAndroid20Regular,
  shield_lock_16_regular: ShieldLockRegular,
  star_filled: Star20Filled,
  star_off: StarOff16Regular,
  star: Star16Regular,
  sun: WeatherSunny16Regular,
  table: Table16Regular,
  task_list_square: TaskListSquareLtr24Regular,
  task_list: TaskListLtr24Regular,
  text_bold: TextBold16Filled,
  text_bullet_list: TextBulletListLtr24Regular,
  text_clear_formatting: TextClearFormatting16Filled,
  text_collapse: TextCollapse24Regular,
  text_color: TextColor16Filled,
  text_expand: TextExpand24Regular,
  text_field_16: TextField16Regular,
  text_indent_decrease: TextIndentDecrease16Filled,
  text_indent_increase: TextIndentIncrease16Filled,
  text_italic: TextItalic16Filled,
  text_number_list: TextNumberListLtr16Filled,
  text_quote: TextQuote16Filled,
  text_strikethrough: TextStrikethrough16Filled,
  text_underline: TextUnderline16Filled,
  timeline: Timeline24Regular,
  timer: Timer24Regular,
  toggle_left: ToggleLeft16Regular,
  warning: Warning16Regular,
  brain_circuit: BrainCircuit20Regular,
  data_bar_horizontal: DataBarHorizontal24Regular,
  table_delete_row: TableDeleteRow24Regular,
  table_delete_column: TableDeleteColumn24Regular,
};

export type FluentIconName = keyof typeof FluentIconsMap;

interface Props {
  icon: FluentIconName;
  rotate?: string;
  size?: string;
  svgClass?: string;
}
const props = withDefaults(defineProps<Props>(), {
  rotate: '',
  size: '24px',
});

function replaceDimensions(svg: string) {
  const svgEl = (() => {
    const el = document.createElement('div');
    el.innerHTML = svg;
    return el.querySelector('svg');
  })();
  if (!svgEl) return svg;
  svgEl.setAttribute('fill', 'currentColor');
  svgEl.setAttribute('height', props.size);
  svgEl.setAttribute('width', props.size);
  const classes = props.svgClass?.split(' ').filter((c) => !!c);
  if (classes?.length) svgEl.classList.add(...classes);
  return svgEl.outerHTML;
}

const svg = computed(() => {
  if (!FluentIconsMap[props.icon] && import.meta.env.MODE !== 'production') {
    console.warn(
      `The ${props.icon} icon passed as a prop to the FluentIcon needs to be imported before it can be used. See the component code for details`
    );
  }
  return replaceDimensions(FluentIconsMap[props.icon]);
});
</script>
